/**
 * OpenInstall 下载/传参，参考 activitycollection a1010
 * 初始化用 URL 参数；真正传给 App 的业务数据走 wakeupOrInstall({ data })
 */
export function kszbOpenInstallDownload(appKey, data = {}) {
  const urlParams = OpenInstall.parseUrlParams();
  console.log(urlParams, data);
  new OpenInstall(
    {
      appKey,
      onready: function () {
        const m = this;
        m.wakeupOrInstall({
          appKey,
          data,
        });
        return false;
      },
    },
    urlParams
  );
}
